exports = module.exports = require("../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".coachee-mensagens .message-input {\n  width: 100%;\n  margin: 0 -10px;\n  margin-bottom: 0px;\n  outline: none;\n  padding-left: 15px;\n  padding-right: 20px;\n  height: 42px;\n  border: 0;\n  color: #333131 !important;\n  font-size: 16px;\n  font-family: 'source_sans_prolight'; }\n", ""]);

